import { createTheme } from '@mui/material'

const theme = createTheme({
  palette: {
    mode: 'dark',
  },
})

export default theme
